/**
 * `placeholderData` for a message-detail query whose key carries the remote
 * mode.
 *
 * "Load images" asks for the same message under a new key (blocked and loaded
 * are two documents, ADR 0018), so the new query starts with no data and the
 * reading pane used to swap the whole message for its skeleton until the
 * server answered: a blink on a fast connection, a blank pane for seconds on a
 * slow one. The message already on screen is the right thing to keep showing
 * meanwhile, and the frame keeps its document until the new body is resolved
 * (MessageFrame's `messageId`).
 *
 * Only the SAME message in the SAME account is kept. Moving to another
 * message still shows the skeleton: a previous message's body must never sit
 * under the next one's header, not even for a frame.
 */
export function sameMessagePlaceholder<T extends { id: string; accountId: string }>(
  previous: T | undefined,
  accountId: string,
  messageId: string,
): T | undefined {
  return previous !== undefined && previous.id === messageId && previous.accountId === accountId
    ? previous
    : undefined;
}
